/**
 * ReferencePersonList Component
 *
 * Renders a grid of ReferencePersonCard components for all
 * active reference persons, plus an AddPersonCard at the end.
 */

import { Loader2 } from 'lucide-react';
import { ReferencePersonCard } from './ReferencePersonCard';
import { AddPersonCard } from './AddPersonCard';
import type { IReferencePersonListProps } from '@/@types/referencePersons';
import { REFERENCE_PERSON_CONSTANTS } from '@/@types/referencePersons';

function ReferencePersonList({
  persons,
  isLoading,
  onEdit,
  onDelete,
  onViewImages,
  onSetDefault,
  onAddPerson,
  canAddPerson,
}: IReferencePersonListProps) {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <Loader2 className="h-8 w-8 text-muted-foreground animate-spin" />
      </div>
    );
  }

  return (
    <div className="grid grid-cols-3 gap-5">
      {persons.map(person => (
        <ReferencePersonCard
          key={person._id}
          person={person}
          onEdit={() => onEdit(person._id)}
          onDelete={() => onDelete(person._id)}
          onViewImages={() => onViewImages(person._id)}
          onSetDefault={() => onSetDefault(person._id)}
          maxImages={REFERENCE_PERSON_CONSTANTS.MAX_IMAGES_PER_PERSON}
        />
      ))}
      <AddPersonCard onClick={onAddPerson} disabled={!canAddPerson} />
    </div>
  );
}

export { ReferencePersonList };
